import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import LinkWrapper from './../LinkWrapper';
import Spinner from './../../../components/Spinner';
import VideoPlayer from './../../../components/video-player/VideoPlayer';

class DesktopGridItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      itemStyle: {
        opacity: 0
      },
      borderStyle: {}
    };
  }

  handleImageLoaded() {
    setTimeout(() => {
      if (this.props.itemData.type !== 'border') {
        let image = this.props.itemData.image.large;
        if (this.props.itemData.type == 'landscape') {
          image = this.props.itemData.image_landscape;
        } else if (this.props.itemData.type == 'portrait') {
          image = this.props.itemData.image_portrait;
        }        
        this.setState({
          loaded: true,
          itemStyle: {
            opacity: 1,
            backgroundImage: `url(${image})`
          }
        });
      } else {
        let image = null;
        if (this.props.itemData.type == 'landscape') {
          image = this.props.itemData.image_landscape;
        } else {
          image = this.props.itemData.image_portrait;
        }        
        this.setState({
          loaded: true,
          itemStyle: {
            opacity: 1,
            backgroundColor: this.props.itemData.bgColor
          },
          borderStyle: {
            backgroundImage: `url(${this.props.itemData.image.large})`
          }
        });
      }
    }, 150);
  }

  render() {
    return (
      <Fragment>
        <div className={(this.props.itemData.black_caption) ? 'grid-item-desktop black-caption' : 'grid-item-desktop'} style={this.state.itemStyle}>
          <LinkWrapper
            linkData={this.props.itemData}
            linkClass={(!this.props.itemData.video && (this.props.video_header_state == 'video-playing') && true)}
            hideCaption={(!this.props.itemData.video && ((this.props.video_header_state == 'video-playing') || (this.props.video_header_state == 'video-paused')) && true)}
          >
            {(this.props.itemData.video)
              ? <div className={'video-wrapper'}>
                  <VideoPlayer videoId={this.props.itemData.video} videoUrl={`https://vimeo.com/${this.props.itemData.video}`} videoPoster={this.props.itemData.image.large} videoCover={false} cta={'PLAY'}/>
                  <img className='hp-image__loader' src={this.props.itemData.image_landscape} onLoad={this.handleImageLoaded.bind(this)}/>
                </div>
              : <img className='hp-image__loader thiswork' src={(this.props.itemData.type == 'portrait')? this.props.itemData.image_portrait : this.props.itemData.image_landscape} onLoad={this.handleImageLoaded.bind(this)}/>
            }
            {(this.props.itemData.type === 'border') &&
              <div className='hp-image__border-inner' style={this.state.borderStyle}/>
            }
            <style jsx>{`
              .video-wrapper {
                width: 103.5%;
                height: 100%;
                display: flex;
                align-items: center;
                position: absolute;
                top: 0;
                left: -1.75%;
                background-color: black;
                z-index: 1;
              }
              .video-wrapper > :global(.video__container) {
                height: 100%;
              }
            `}</style>
          </LinkWrapper>
        </div>
        {(!this.state.loaded) && <Spinner/> }
      </Fragment>
    );
  }
};

export default connect(
  state => ({
    video_header_state: state.video_state.header_style
  })
)(DesktopGridItem);



// WEBPACK FOOTER //
// ./src/pages/home/desktop-grid/DesktopGridItem.js